export enum ExportMimetype {
  TXT = 'text/plain',
  CSV = 'text/csv',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
